import { render, staticRenderFns } from "./_migration.vue?vue&type=template&id=d35add52&scoped=true&lang=pug&"
import script from "./_migration.vue?vue&type=script&lang=js&"
export * from "./_migration.vue?vue&type=script&lang=js&"
import style0 from "./_migration.vue?vue&type=style&index=0&id=d35add52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35add52",
  null
  
)

export default component.exports